import React from 'react';
import classNames from 'classnames';
import { Heading as BaseHeading } from '@fiverr-private/typography';

import * as styles from './styles.ve.css';

interface CustomHeadingProps {
  children: React.ReactNode;
  className?: string;
  [key: string]: any;
}

export const Heading: React.FC<CustomHeadingProps> = ({ children, className, ...props }) => (
  <BaseHeading color="white" className={classNames(styles.headingStyles, className)} {...props}>
    {children}
  </BaseHeading>
);
